import { sortBy } from 'lodash';

export const getFilteredOrderedOptions = <TOption>(
  inputValue: string | null,
  options: Array<TOption>,
  getOptionText: (option: TOption) => string,
): Array<TOption> => {
  if (!inputValue) {
    return options;
  }
  const searchTerm = inputValue.trim().toLowerCase();
  return sortBy(
    options
      .map(option => ({ priority: getPriority(searchTerm, getOptionText(option)), option }))
      .filter(searchResult => searchResult.priority != null),
    searchResult => searchResult.priority,
  ).map(searchResult => searchResult.option);
};

const getPriority = (searchTerm: string, optionText: string) => {
  const lowerCasedOptionText = optionText.toLowerCase();
  if (searchTerm === lowerCasedOptionText) {
    return 0; // If we have an exact match, this takes the highest priority
  }
  const index = lowerCasedOptionText.indexOf(searchTerm);
  // If no match, return null so it will be filtered out
  // Otherwise, return index + 1 so that nothing clashes with the exact match above
  return index === -1 ? null : index + 1;
};
